import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import {
  valueHandler,
  handleColorSelection,
} from '../helpers/progressValueColor';

const defaultRules = {
  success: {
    top: 100,
    bottom: 90,
  },
  warning: {
    top: 89,
    bottom: 80,
  },
};

const PercentageGauge = ({
  percentageValue = 0,
  rules = defaultRules,
  additionalText = '%',
}) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: theme => theme.palette.divider }}
        size={70}
        thickness={5}
      />
      <CircularProgress
        variant="determinate"
        value={valueHandler(percentageValue)}
        color={handleColorSelection(valueHandler(percentageValue), rules)}
        size={70}
        data-testid={'color-gauge'}
        sx={{
          position: 'absolute',
          left: 0,
        }}
        thickness={5}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="subtitle2" component="div" color="text.primary">
          {`${
            additionalText === '%' ? valueHandler(percentageValue) : ''
          }${additionalText}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default PercentageGauge;
